import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getLinks, hasAnyLink, useSite } from "@/lib/content";
import { setLang, t } from "@/lib/i18n";
import { toLang } from "@/lib/routes";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PreviewBanner from "@/components/PreviewBanner";
import BottomBar from "@/components/BottomBar";
import AdminBar from "@/components/AdminBar";

export default function Layout({ lang }) {
  setLang(lang);
  const { content, ready, error, isPreview, isAdmin, enLive } = useSite();
  const { pathname, hash } = useLocation();
  const links = getLinks(content, isPreview);
  const barLinks = { phone: links.phone, whatsapp: links.whatsapp, directions: links.directions };
  const showBar = hasAnyLink(barLinks);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash, ready]);

  if (lang === "en" && ready && !enLive && !isAdmin) return <Navigate to={toLang(pathname, "tr", hash)} replace />;

  return (
    <div className={`min-h-screen flex flex-col ${showBar ? "has-bar" : ""}`} data-testid="site-root" data-mode={isPreview ? "preview" : "live"} data-lang={lang}>
      <a href="#icerik" className="skip-link" data-testid="skip-to-content-link">{t("skip")}</a>
      {isAdmin && <AdminBar />}
      {isPreview && <PreviewBanner />}
      <Header />
      <main id="icerik" tabIndex={-1} className="flex-1 outline-none">
        {!ready && <div className="min-h-[70vh]" aria-busy="true" data-testid="page-loading" />}
        {ready && error && (
          <p className="max-w-3xl mx-auto px-6 py-32 text-center text-ink-muted" role="alert" data-testid="content-error">{t("error")}</p>
        )}
        {ready && !error && <Outlet />}
      </main>
      <Footer />
      {showBar && <BottomBar links={barLinks} />}
    </div>
  );
}
